import React, { Fragment } from "react";
import styled, { ThemeProvider, keyframes } from "styled-components";
import { Flex, Headline, Wrapper, Icon } from "contist-ui";
import { Link } from "@reach/router";

const Text = styled.div`
  h2,
  h3,
  h3 {
    color: #fff;
    margin: 30px 0 10px 0;
    font-weight: 300;
  }
  span,
  li {
    color: rgba(255, 255, 255, 0.6);
  }
  p {
    color: rgba(255, 255, 255, 0.6);
    font-size: 1rem;
    line-height: 1.4rem;
    margin-top: 30px;
    font-weight: 300;
  }
`;

export default () => (
  <Wrapper padding="5rem 0" style={{ width: "85%" }}>
    <Flex alignItems="center">
      <Link to="/">
        <Icon type="arrow-left" size={40} color="#FFF" />
      </Link>
      <Headline as="h1" color="#FFF" marginLeft="10px" animated>
        Privacy
      </Headline>
    </Flex>
    <Text>
      <p>
        Diese Datenschutzerklärung gilt für das Produkt Lyno, der Firma Spicy
        Media GmbH.
      </p>
      <p>
        Die Spicy Media GmbH, Königsallee 27 40212 Düsseldorf (nachfolgend
        „Spicy Media GmbH " oder „wir/uns") betreibt unter der Domain
        „getlyno.com" und mithilfe der für verschiedene Betriebssysteme zum
        Download bereitstehenden mobilen App Lyno (nachfolgend: „Lyno“) eine
        Plattform zum Chatten, Kennenlernen und Flirtne mit anderen Menschen.{" "}
        <br />
        Der Nutzer von Lyno kann sich (nachfolgend: „Nutzer" oder „Du")
        kostenlos über die Lyno-Domain bzw. Lyno-App ein Profil (nachfolgend:
        „Nutzerprofil") erstellen, Bilder hochladen und sich mit anderen Nutzern
        und deren Nutzerprofilen bei Interesse austauschen. Der Nutzer hat die
        Möglichkeit, Funktionen wie den Chat sowie viele weitere Funktionen von
        Lyno in Anspruch zu nehmen. Eine Registrierung ist ab 18 Jahren möglich.{" "}
        <br />
        Deine Daten werden nach den Bestimmungen des Telemediengesetzes (TMG)
        und des Datenschutzrechts, insbesondere des Bundesdatenschutzgesetzes
        (BDSG) – ab dem 25. Mai 2018 der Datenschutz-Grundverordnung (DS-GVO) –
        erhoben, verarbeitet und genutzt. <br />
        Diese Datenschutzerklärung erläutert den Umgang mit personenbezogenen
        Daten. Personenbezogene Daten sind Einzelangaben über persönliche oder
        sachliche Verhältnisse einer bestimmten oder bestimmbaren natürlichen
        Person. Dazu gehören z.B. Name, Geburtstag, Telefonnummer aber auch
        E-Mail-Adresse und Nutzungsdaten, wie zum Beispiel die IP-Adresse.
        Weiterhin dient die Datenschutzerklärung der Information darüber, welche
        Daten erhoben, gespeichert und verarbeitet werden und wie die Minnie
        Partners UG den Schutz und die Sicherheit der personenbezogenen Daten
        gewährleistet. <br />
        Die Spicy Media GmbH verzichtet auf einen Klarnamenzwang. Der Nutzer
        kann anstelle eines Namens auch ein Pseudonym angeben. <br />
        <strong>
          a. Wie werden meine Daten beim Download der Lyno-App erhoben,
          verarbeitet und genutzt?
        </strong>{" "}
        <br />
        a.1. Download der Lyno-App <br />
        Beim Herunterladen der Lyno-App werden die dafür notwendigen
        Informationen an den jeweiligen App-Store-Betreiber übertragen. Dies
        sind je nach App-Store beispielsweise die E-Mail-Adresse oder die
        Kundennummer des App-Store-Benutzers des jeweiligen App-Stores, der
        Zeitpunkt des Downloads und eine individuelle Gerätekennziffer. Auf
        diese Datenerhebung hat die Spicy Media GmbH jedoch keinen Einfluss und
        ist nicht dafür verantwortlich. Es gelten die entsprechenden
        Datenschutzerklärungen/ Einstellungen des jeweiligen App-Store
        Betreibers. <br />
        Die Spicy Media GmbH verarbeitet die vom jeweiligen App-Store-Betreiber
        bereitgestellten Daten, soweit dies für das Herunterladen der Lyno-App
        auf das Endgerät notwendig ist. <br />
        a.2. Installation und Berechtigungen <br />
        Zur technischen Funktionsfähigkeit der Lyno-App und zur Bereitstellung
        der mit der Lyno-App angebotenen Dienste benötigt Lyno verschiedene
        Zugriffsmöglichkeiten und Informationen. <br />
        Je nach Betriebssystem wird bereits beim Installationsvorgang eine
        Erlaubnis für den Zugriff auf einzelne Funktionen und Informationen
        abgefragt. Die Zugriffsberechtigungen umfassen unter anderem den
        Standort, die Benachrichtigungen sowie die mobilen Daten. <br />
        Unter den Einstellungen des Endgeräts können diese Berechtigungen zum
        Teil manuell entzogen werden. Dabei ist jedoch zu berücksichtigen, dass
        die Lyno-App ohne entsprechende Freigaben nur eingeschränkt bzw. gar
        nicht genutzt werden kann. Je nach App-Version werden vor oder nach der
        Installation Berechtigungen abgefragt. <br />
        <strong>
          b. Wie werden meine Daten bei Besuch der Lyno-Domain bzw. der Lyno-App
          ohne Erstellen eines Nutzerprofils bei Lyno erhoben, verarbeitet und
          genutzt?
        </strong>{" "}
        <br />
        Die Spicy Media GmbH verwendet die personenbezogenen Daten, die der
        Nutzer mitteilt oder die bei der Nutzung von Lyno ohne Erstellen eines
        Nutzerprofils anfallen, ohne gesonderte Einwilligung ausschließlich zur
        Durchführung des Nutzungsverhältnisses und wie entsprechend in dieser
        Datenschutzerklärung dargestellt. <br />
        Beim bloßen Besuch der Lyno-Domain (auf einer sogenannten
        Landing-Page/Startseite) bzw. Installation der Lyno-App ohne Erstellung
        eines Nutzerprofils, erhebt die Spicy Media GmbH &nbsp;die folgenden
        Daten, die das Endgerät bzw. der Browser des Nutzers übermittelt: <br />
        IP-Adresse Name der aufgerufenen Webseite, Datei, Datum und Uhrzeit der
        Anfrage übertragene Datenmenge Browsertyp und -version Referrer-URL
        (Herkunfts-URL), von der der Nutzer auf die abgerufene Seite gekommen
        ist <br />
        Sowie zusätzlich bei der bloßen Installation der Lyno-App ohne
        Registrierung oder Erstellung eines Nutzerprofils folgende Daten, die
        das verwendete Endgerät des Nutzers übermittelt: <br />
        Push Handle (zum Verschicken von Push Nachrichten) Standortdaten (GPS
        Location) Ländercode Sprache Gerätename Name des Betriebssystems und
        –version <br />
        Diese Daten sind für die Nutzung der Lyno-Domain bzw. Installation der
        Lyno-App als solche erforderlich bzw. dienen der Auswertung zu
        statistischen Zwecken zur Optimierung von Lyno. Die Daten werden zur
        Prävention und Bekämpfung von rechtswidrigen Handlungen und Spam sowie
        der Sicherstellung der Integrität und Stabilität der Lyno Plattform
        verarbeitet und genutzt. <br />
        Die Standortdaten werden erhoben, verarbeitet und genutzt, damit der
        Nutzer den sogenannten Location Based Service nutzen kann, mit welchen
        ihm ab Registrierung Vorschläge geboten werden, die auf den jeweiligen
        Standort zugeschnitten sind. Näheres zur Nutzung der Standortdaten siehe
        auch unter den Punkten c.3 und c.3. <br />
        Weiterhin nutzt Lyno Cookies (siehe Punkt d.1), Analysedienste und
        Trackinganbieter (siehe Punkt d.2). <br />
        <strong>
          c. Wie werden meine Daten nach Erstellen eines Nutzerprofils und bei
          der Nutzung des Angebots der Lyno-App bzw. Lyno-Domain erhoben,
          verarbeitet und genutzt?
        </strong>{" "}
        <br />
        Die Spicy Media GmbH verwendet die personenbezogenen Daten, die der
        Nutzer mitteilt oder die bei der Nutzung von Lyno nach Erstellen eines
        Nutzerprofils anfallen, ohne gesonderte Einwilligung ausschließlich zur
        Durchführung des Nutzungsverhältnisses und wie entsprechend in dieser
        Datenschutzerklärung dargestellt. Für eine Nutzung von Lyno im vollem
        Umfang ist es notwendig, dass sich der Nutzer ein Nutzerprofil erstellt.
        Dazu muss der Nutzer weitere personenbezogene Daten angeben, die die
        Spicy Media GmbH zur Erbringung der jeweiligen Leistung nutzt. <br />
        c.1 Pflichtangaben bei der Erstellung des Nutzerprofils <br />
        Bei der Erstellung des Nutzerprofils und Registrierung müssen oder
        können folgende Angaben gemacht werden: <br />
        Geschlecht <br />
        Alter <br />
        Nutzername (Pseudonym, Nickname) <br />
        Stadt <br />
        E-Mail-Adresse <br />
        Passwort <br />
        Profilbild <br />
        Die angegebenen Daten werden zum Zweck der Nutzung von Lyno erhoben,
        verarbeitet und genutzt. Unter anderem dienen die Angaben zur Ansprache,
        zur Authentifizierung, zur Altersverifikation, zur Personalisierung des
        Profils, zur Anzeige anderer passender Nutzerprofile sowie für
        Werbezwecke (siehe auch Punkt d). <br />
        c.2 Freiwillige Daten <br />
        Der Nutzer kann in seinem Nutzerprofil eine Vielzahl freiwilliger
        Angaben machen. Dies dient insbesondere der Funktion von Lyno,
        Empfehlungen für andere Nutzerprofile nach unterschiedlichen Kriterien
        für den Nutzer auszuwählen und innerhalb von Lyno anzuzeigen. Durch
        zusätzliche Informationen erhöht sich die Wahrscheinlichkeit, mit
        passenden Nutzerprofilen in Kontakt zu kommen. Diese Angaben sind für
        den Nutzer freiwillig und können im Profil unter Details eingesehen bzw.
        eingetragen, geändert oder gelöscht werden. <br />
        Die angegebenen Daten werden zum Zweck der Nutzung von Lyno von uns
        erhoben, verarbeitet und genutzt. <br />
        Diese freiwilligen Angaben sind für andere eingeloggte Nutzer innerhalb
        von Lyno als „öffentlich" sichtbar, können aber vom Nutzerprofilinhaber
        jederzeit unter den Einstellungen innerhalb des Nutzerprofils gelöscht
        oder abgeändert werden. <br />
        c.3 Standortdaten <br />
        Das Angebot von Lyno umfasst auch sogenannte Location Based Services,
        mit welchen dem Nutzer spezielle Angebote dargestellt werden, die auf
        den jeweiligen Standort zugeschnitten sind. Dadurch können dem Nutzer
        insbesondere andere Nutzer, die sich in dessen Nähe befinden, angezeigt
        werden. Um diese Funktionen innerhalb der Lyno-App anbieten zu können,
        erhebt Lyno Standortdaten mittels GPS des verwendeten Endgeräts sowie
        Standortdaten über nahegelegene Funkzugangsknoten. Wenn die
        Standorterhebung aktiv ist, wird der Standort bei Erlaubnis regelmäßig
        an die Spicy Media GmbH übertragen und dort verarbeitet und genutzt.{" "}
        <br />
        Der Nutzer kann diese Funktion in den Einstellungen des Betriebssystems
        auf seinem Endgerät jederzeit anpassen, d.h. das Erfassen der
        Standortdaten erlauben oder deren Nutzung widerrufen. <br />
        c.4 IP-Adressen <br />
        Die IP-Adressen der Nutzer werden zu Sicherheits- und Prüfzwecken
        aufgezeichnet. Damit soll ein Missbrauch des Dienstes verhindert werden.
        Die Daten werden zur Prävention und Bekämpfung von rechtswidrigen
        Handlungen und Spam sowie der Sicherstellung der Integrität und
        Stabilität der Lyno Plattform verarbeitet und genutzt. <br />
        c.5 Zahlungsdaten <br />
        Wenn der Nutzer In-App-Käufe über Lyno tätigt, also digitale
        Währungseinheiten kauft geschieht dies über externe Zahlungsanbieter.
        Von der Spicy Media GmbH werden bei einem Kauf keine Zahlungsdaten
        erhoben und verarbeitet. Die Eingabe sowie Verarbeitung der
        Zahlungsdaten erfolgt direkt bei den Zahlungsanbietern. Zwischen der
        Spicy Media GmbH und den Zahlungsanbietern werden technische Daten (u.a.
        die Transaktion ID) zur Validierung der Käufe ausgetauscht. <br />
        <strong>
          d. Welche Cookies, Trackinganbieter, Analysedienste nutzt Lyno? Wie
          sind Social Media und Like-Buttons eingebunden?
        </strong>{" "}
        <br />
        d.1 Cookies und Cookie-Policy <br />
        Um die Lyno-Domain möglichst komfortabel nutzen zu können, setzen wir
        auf der Lyno-Domain Cookies ein. Bei Cookies handelt es sich um kleine
        Textdateien, die lokal im Zwischenspeicher des Internet-Browsers (sog.
        Session Cookies) oder auf der Festplatte des verwendeten mobilen
        Endgerätes oder des Computers (sog. permanent Cookies) gespeichert
        werden. Die Browsereinstellungen können so gewählt werden, dass Cookies
        abgelehnt oder vor dem Setzen der Cookies auf diese hingewiesen wird.
        Durch das Setzen von Cookies werden den Nutzern pseudonymisierte IDs
        zugewiesen. Es werden durch Cookies keine Programme auf dem verwendeten
        Endgerät des Nutzers ausgeführt oder gar Viren übertragen. Session
        Cookies werden nach Ende der Browser-Sitzung aus dem Zwischenspeicher
        gelöscht. <br />
        Die Spicy Media GmbH verwendet Cookies auch, um die Sicherheit der
        Lyno-Domain zu erhöhen. Beispielsweise zur Authentifizierung des Nutzers
        während einer Sitzung, zur Vermeidung von Cross-Site-Scripting oder zur
        Unterbindung von Phishing und betrügerischen Handlungen, wie Scamming.{" "}
        <br />
        Weiterhin setzen Trackinganbieter/Analysedienste (siehe dazu auch die
        Ausführungen unter Punkt 4.2 Verwendung zum Einsatz von
        Trackinganbietern/Analysediensten) im Auftrag von der Spicy Media GmbH
        Cookies auf das Endgerät des Nutzers, um die Nutzungsdaten zu erfassen.
        Hierbei handelt es sich um solche Daten, die erhoben werden können,
        während der Nutzer sich z. B. auf den Seiten der Lyno-Domain bewegt oder
        Werbung anklickt. Diese Cookies werden dazu verwendet, um zielgerichtete
        Werbung anzuzeigen, Berichte zu Werbekampagnen zu optimieren und um zu
        vermeiden, dass identische Werbung mehrfach angezeigt wird. <br />
        Die Nutzer können auf den Einsatz der Cookies Einfluss nehmen. Die
        meisten Browser verfügen über eine Einstellungs-Option mit der das
        Speichern von Cookies eingeschränkt oder komplett verhindert wird.
        Allerdings weisen wir darauf hin, dass die Nutzung und insbesondere der
        Nutzungskomfort von Lyno ohne Verwendung von Cookies eingeschränkt sein
        kann. <br />
        d.2 Trackinganbieter, Analysedienste <br />
        Um die Leistungen von Lyno zu optimieren und bestmöglich anbieten zu
        können, werden von Lyno Analysen des Besucherverhaltens durchgeführt.
        Hierfür setzt die Spicy Media GmbH Analyse-Verfahren ein, mit denen
        Besuche auf der Lyno-Domain bzw. Lyno-App analysiert werden können.
        Weiterhin kommen Trackingtools von Drittanbietern zum Einsatz, durch
        welche die Reichweite von unterschiedlichen Werbekampagnen und
        Marketing-Aktionen analysiert werden kann. Beim Einsatz von
        Drittanbieter-Tools können auch personenbezogene Daten übermittelt
        werden. <br />
        Zweck der Datenverarbeitung ist neben der Fehlerbehebung vor allem die
        Optimierung von Lyno im Hinblick auf die Bedürfnisse der Nutzer. Auch
        erhält die Spicy Media GmbH über das Webanalyse-Verfahren Kennzahlen
        über das Besucheraufkommen und deren zeitliche Verteilung, über beliebte
        Inhalte sowie die Verweildauer von Nutzern. Es kann gegebenenfalls
        nachvollzogen werden, ob ein Nutzerprofil aufgrund einer Werbemaßnahme
        erstellt wurde. Die Daten werden zur Prävention und Bekämpfung von
        Fakeprofilen, rechtswidrigen Handlungen und Spam sowie der
        Sicherstellung der Sicherheit der Lyno Plattform verarbeitet und
        genutzt. Zur Durchführung der Analyse werden Nutzerdaten an verschiedene
        Drittanbieter übermittelt. <br />
        Die folgende Analyse- und Tracking-Anbieter kommen bei Lyno derzeit zum
        Einsatz: <br />
        Google Analytics <br />
        Lyno verwendet "Google Analytics", ein Angebot der Firma Google Inc.,
        1600 Amphitheatre Parkway, Mountain View, CA 94043, USA (nachfolgend:
        „Google"). Die Spicy Media GmbH weist darauf hin, dass bei der Nutzung
        von Lyno Google Analytics um die IP-Masking Funktion „_gat.
        _anonymizeIp" erweitert wurde, um eine anonymisierte Erfassung von
        IP-Adressen zu gewährleisten. <br />
        Nachfolgende Informationen zum Einsatz von Google Analytics sind zu
        beachten: <br />
        Google Analytics verwendet Cookies, die auf dem Gerät gespeichert werden
        und die eine Analyse der Benutzung von Lyno ermöglichen. Die durch das
        Cookie erzeugten Informationen über Ihre Benutzung von Lyno werden in
        der Regel an einen Server von Google in den USA übertragen und dort
        gespeichert. Durch Aktivierung der IP-Anonymisierung wird die IP-Adresse
        von Google jedoch innerhalb von Mitgliedstaaten der Europäischen Union
        oder in anderen Vertragsstaaten des Abkommens über den Europäischen
        Wirtschaftsraum zuvor gekürzt. Im Auftrag von Minnie Partners UG wird
        Google diese Informationen benutzen, um die Nutzung unseres Dienstes
        auszuwerten, um Reports über Aktivitäten zusammenzustellen und um
        weitere mit der Nutzung verbundene Dienstleistungen gegenüber dem
        Betreiber zu erbringen. <br />
        Hiergegen hat der Nutzer eine Widerspruchsmöglichkeit: <br />
        Der Datenerhebung und -speicherung durch Google Analytics kann jederzeit
        mit Wirkung für die Zukunft widersprochen werden. Der Nutzer hat dazu
        die Möglichkeit, ein von Google herausgegebenes Browser-Plugin zu
        installieren. Dieses steht für verschiedene Browser-Versionen zur
        Verfügung und kann{" "}
        <a
          href="https://tools.google.com/dlpage/gaoptout?hl=de"
          target="_blank"
        >
          hier
        </a>{" "}
        heruntergeladen werden. Weitere Informationen zur Datennutzung zu
        Werbezwecken durch Google, Einstellungs- und Widerspruchsmöglichkeiten
        erfahren Sie auf den Webseiten von Google: <br />
        („
        <a
          href="https://www.google.com/intl/de/policies/privacy/partners/"
          target="_blank"
        >
          Datennutzung durch Google bei Ihrer Nutzung von Websites oder Apps
          unserer Partner
        </a>
        "), <br />
        („
        <a
          href="https://www.google.com/policies/technologies/ads"
          target="_blank"
        >
          Datennutzung zu Werbezwecken
        </a>
        "), <br />
        („
        <a href="https://www.google.de/settings/ads" target="_blank">
          Informationen verwalten, die Google verwendet, um Ihnen Werbung
          einzublenden
        </a>
        ") und <br />
        („
        <a href="https://www.google.com/ads/preferences/" target="_blank">
          Bestimmen Sie, welche Werbung Google Ihnen zeigt
        </a>
        "). <br />
        Adjust <br />
        Lyno nutzt das App-Nutzungs-Analyse-Tool "adjust", ein Produkt der Firma
        adjust GmbH, Saarbrücker Str. 37 a in 10405 Berlin, Deutschland. Wenn
        der Nutzer die Lyno-App installiert, speichert adjust Installations- und
        Ereignis-Daten von der iOS oder Android App. Damit können wir verstehen,
        wie unsere Nutzer mit der Lyno-App interagieren. Ferner können wir
        unsere mobilen Werbekampagnen dadurch analysieren und verbessern. Für
        diese Analyse nutzt adjust die IDFA oder Advertiser-ID, sowie deine
        anonymisierte IP- und MAC Adresse. Die Daten sind einseitig
        anonymisiert, d.h. es ist nicht möglich dich oder dein mobiles Gerät
        dadurch zu identifizieren. Wenn du kein Tracking durch adjust wünschst,
        wähle das bitte{" "}
        <a href="https://www.adjust.com/forget-device/" target="_blank">
          hier
        </a>{" "}
        aus. <br />
        Rapidmail <br />
        Der Versand der Newsletter und anderer E-Mails erfolgt mittels des
        Versanddienstleisters rapidmail GmbH, Augustinerplatz 2, 79098 Freiburg
        i.Br., Deutschland. Die Datenschutzbestimmungen des
        Versanddienstleisters können Sie{" "}
        <a href="https://www.rapidmail.de/datenschutz" target="_blank">
          hier
        </a>{" "}
        einsehen. Der Versanddienstleister wird auf Grundlage unserer
        berechtigten Interessen gem. Art. 6 Abs. 1 lit. f DSGVO und eines
        Auftragsverarbeitungsvertrages gem. Art. 28 Abs. 3 S. 1 DSGVO
        eingesetzt. <br />
        Google-Tag-Manager <br />
        Wir benutzen den Google Tag Manager. Google Tag Manager ist eine Lösung,
        mit der Vermarkter Website-Tags über eine Oberfläche verwalten können.
        Das Tool Tag Manager selbst (das die Tags implementiert) ist eine
        cookielose Domain und erfasst keine personenbezogenen Daten. Das Tool
        sorgt für die Auslösung anderer Tags, die ihrerseits unter Umständen
        Daten erfassen. Google Tag Manager greift nicht auf diese Daten zu. Wenn
        auf Domain- oder Cookie-Ebene eine Deaktivierung vorgenommen wurde,
        bleibt diese für alle Tracking-Tags bestehen, die mit Google Tag Manager
        implementiert werden. <br />
        Google Adwords <br />
        Wir nutzen das Online-Werbeprogramm "Google AdWords" und im Rahmen von
        Google AdWords das Conversion-Tracking. Das Google Conversion Tracking
        ist ein Analysedienst der Google Inc. (1600 Amphitheatre Parkway,
        Mountain View, CA 94043, USA; "Google"). Wenn Sie auf eine von Google
        geschaltete Anzeige klicken, wird ein Cookie für das Conversion-Tracking
        auf Ihrem Rechner abgelegt. Diese Cookies haben eine begrenzte
        Gültigkeit, enthalten keine personenbezogenen Daten und dienen somit
        nicht der persönlichen Identifizierung. Wenn Sie bestimmte
        Internetseiten unserer Website besuchen und das Cookie noch nicht
        abgelaufen ist, können Google und wir erkennen, dass Sie auf die Anzeige
        geklickt haben und zu dieser Seite weitergeleitet wurden. Jeder Google
        AdWords-Kunde erhält ein anderes Cookie. Somit besteht keine
        Möglichkeit, dass Cookies über die Websites von AdWords-Kunden
        nachverfolgt werden können. Die Informationen, die mit Hilfe des
        Conversion-Cookie eingeholt werden, dienen dazu, Conversion-Statistiken
        für AdWords-Kunden zu erstellen, die sich für Conversion-Tracking
        entschieden haben. Hierbei erfahren die Kunden die Gesamtanzahl der
        Nutzer, die auf ihre Anzeige geklickt haben und zu einer mit einem
        Conversion-Tracking-Tag versehenen Seite weitergeleitet wurden. Sie
        erhalten jedoch keine Informationen, mit denen sich Nutzer persönlich
        identifizieren lassen. Wenn Sie nicht am Tracking teilnehmen möchten,
        können Sie dieser Nutzung widersprechen, indem Sie die Installation der
        Cookies durch eine entsprechende Einstellung Ihrer Browser Software
        verhindern (Deaktivierungsmöglichkeit). Sie werden sodann nicht in die
        Conversion-Tracking Statistiken aufgenommen. Weiterführende
        Informationen sowie die Datenschutzerklärung von Google finden Sie{" "}
        <a href="https://www.google.de/policies/privacy/" target="_blank">
          hier
        </a>
        . <br />
        <strong>e. Wie werden Daten offengelegt bzw. weitergegeben</strong>{" "}
        <br />
        Die Spicy Media GmbH leitet personenbezogenen Daten der Nutzer nicht an
        Dritte weiter, es sei denn, es liegt eine Einwilligung des Nutzers dazu
        vor, die Übermittlung ist gesetzlich vorgeschrieben oder gesetzlich
        zulässig. <br />
        e.1 Allgemeine Hinweise zur Weitergabe von personenbezogenen Daten{" "}
        <br />
        Nutzerdaten und sonstige Daten <br />
        Lyno darf Kundendaten zur Vertragsdurchführung an Folgende Dritte
        weitergeben: <br />
        Externe Serviceanbieter und Vertreter. Lyno kann externe Unternehmen
        oder Personen mit der Verarbeitung von Kundendaten beauftragen.
        Verbundene Unternehmen. Lyno kann verbundene Unternehmen mit der
        Verarbeitung von Kundendaten beauftragen. <br />
        Sonstige Offenlegungen <br />
        Lyno darf Kundendaten wie folgt weitergeben bzw. offenlegen: <br />
        Im Rahmen von Änderungen der Geschäftsstruktur. Im Zusammenhang mit
        Fusionen, Übernahmen, Insolvenzverfahren, Auflösungsverfahren,
        Restrukturierungsmaßnahmen, Veräußerungen eines Teils oder aller
        Vermögensgegenstände von Lyno, Finanzierungen, Übernahmen eines Teils
        oder unseres gesamten Geschäfts, ähnlichen Transaktionen oder Verfahren
        oder Schritten in Erwägung derartiger Aktivitäten (z. B. Due Diligence).
        Im Rahmen der gesetzlichen Vorschriften. Zur Einhaltung gesetzlicher
        Bestimmungen oder behördlicher Auflagen und in Reaktion auf rechtmäßige
        Anfragen, Gerichtsbeschlüsse und Rechtsverfahren. Im Rahmen der
        Durchsetzung der Rechte der Spicy Media GmbH, zur Verhinderung von
        Betrug und zur Gewährleistung der Sicherheit. Zum Schutz und zur
        Verteidigung der Rechte, des Eigentums bzw. der Sicherheit von Lyno oder
        Dritten, einschließlich der Durchsetzung von Verträgen und Richtlinien,
        sowie im Zusammenhang mit der Untersuchung und Verhinderung von Betrug.
        Lyno darf aggregierte oder um personenbezogene Merkmale bereinigte Daten
        für jeden Zweck verwenden. Lyno kann z. B. aggregierte oder um
        personenbezogene Merkmale bereinigte Daten an Partner oder andere für
        geschäftliche oder Analysezwecke weitergeben, indem Lyno etwa
        veröffentlicht wie viele Nachrichten über Lyno an einem Tag versenden
        werden. <br />
        e.2 Kategorien von Datenempfängern <br />
        Lyno nutzt derzeit externe Datenauftragsverarbeiter für die folgenden
        Dienste: <br />
        Services zum Versand von E-Mail-Benachrichtigungen (z.B. Rapidmail)
        Analyse und Tracking Dienste (siehe Punkt 4.2) Abhängig von der Art der
        bereitgestellten Dienstleistungen kann Lyno auch verbundene Unternehmen
        als Datenauftragsverarbeiter für die Bereitstellung einiger oder aller
        dem Kunden gebotenen Services hinzuziehen. <br />
        <strong>
          f. Wie läuft die Datenlöschung und das Erstellen von Backups ab?
        </strong>{" "}
        <br />
        Mit der Löschung des Nutzerprofils (Achtung: Nicht durch Löschung der
        Lyno-App!) bzw. entsprechender Benachrichtigung an uns, werden alle
        erhobenen Daten des Nutzers gelöscht. Davon ausgenommen bleiben Daten,
        die aufgrund gesetzlicher Vorschriften oder zur Vertragsabwicklung
        vorgehalten werden müssen. Darüber hinaus kann der Nutzer zu jeder Zeit
        die Löschung von einzelnen Daten im Profil selbst vornehmen bzw. bei uns
        über eine entsprechende Benachrichtigung beantragen. Eine Löschung aus
        den Produktiv-Datenbanken und somit aus der Oberfläche von Lyno erfolgt
        innerhalb von 48 Stunden. <br />
        Die Spicy Media GmbH behält es sich vor, Profil-Dateien vor einer
        Löschung zu überprüfen und gegebenenfalls zu sichern, wenn bei den
        Nutzungsprofilen aufgrund bestimmter Tatsachen der Verdacht besteht,
        dass diese Lyno gesetzes- oder vertragswidrig nutzen. Dies dient dem
        Schutz der Nutzer der Angebote der Spicy Media GmbH . <br />
        Unabhängig von der durch Profillöschung durch den Nutzer angestoßenen
        Löschung der Daten, löscht Lyno historische Daten, die zur
        Vertragserfüllung nicht weiter benötigt werden (z.B. historische
        Standortdaten sowie IP-Daten) automatisiert in regelmäßigen Abständen.{" "}
        <br />
        <strong>
          g. Welche Maßnahmen zur Datensicherheit gibt es bei Lyno?
        </strong>{" "}
        <br />
        Die Spicy Media GmbH nimmt das Vertrauen der Nutzer und den Schutz der
        Daten äußerst wichtig. Um unbefugten Zugriff auf Nutzerdaten oder deren
        Preisgabe zu verhindern, um die Integrität der Daten zu bewahren und die
        angemessene Verwendung der Daten zu gewährleisten, setzt die Minnie
        Partners UG &nbsp;geeignete physische, technische und administrative
        Verfahren zum Schutz der von der Spicy Media GmbH &nbsp;erhobenen
        Informationen ein. <br />
        Für einen bestmöglichen Schutz der Daten des Nutzers erfolgt das Angebot
        der Lyno-Domain bzw. Lyno-App über eine gesicherte SSL Verbindung, d.h.
        die Daten werden sowohl zwischen den Servern und dem Browser als auch
        zwischen den Servern und der App verschlüsselt übertragen. <br />
        <strong>
          h. Rechte des Nutzers: Einwilligung und Widerruf, Auskunft,
          Berichtigung, Löschung, Übertragung
        </strong>{" "}
        <br />
        h.1 Einwilligung und Widerruf <br />
        Im Rahmen der Registrierung bei Lyno willigt der Nutzer ein, dass seine
        personenbezogenen Daten nach Maßgabe dieser Datenschutzerklärung und
        gemäß der AGB erhoben, gespeichert und verarbeitet werden. Diese
        Einwilligung muss der Nutzer bei Erstellung des Nutzerprofils
        ausdrücklich erklären. Diese Einwilligung wird ebenso wie der gesamte
        Vorgang der Erstellung des Nutzerprofils von Spicy Media GmbH
        protokolliert. <br />
        Eine Einwilligung kann der Nutzer jederzeit mit Wirkung für die Zukunft
        widerrufen. Dies kann erfolgen durch Löschung des Nutzerprofils (nicht
        der Lyno-App), an den angegebenen Stellen in der Lyno-App bzw.
        Lyno-Domain innerhalb des Nutzerprofils oder per E-Mail an uns: <br />
        E-Mail: hello@spicymedia.io. &nbsp;
        <br />
        h.2 Auskunft, Berichtigung, Löschung, Übertragung <br />
        Der Nutzer hat nach den geltenden Gesetzen einen Anspruch auf
        unentgeltliche Auskunft über die von ihm gespeicherten personenbezogenen
        Daten sowie gegebenenfalls ein Recht auf Berichtigung und/oder Löschung
        bzw. Übertragung dieser Daten. <br />
        Der Nutzer kann sich dazu z.B. per E-Mail an hello@spicymedia.io wenden.{" "}
        <br />
        <strong>i. Änderung der Datenschutzerklärung</strong> <br />
        Die Spicy Media GmbH wird diese Datenschutzerklärung gegebenenfalls
        aktualisieren. Die Verwendung der Nutzer-Daten unterliegt der jeweils
        aktuellen Version, diese kann jederzeit unter{" "}
        <a href="http://www.getlyno.co">getlyno.com</a> abgerufen werden.
        <br />
        <strong>j. Fragen zum Datenschutz</strong> <br />
        Sollten Sie noch Fragen oder Bedenken zum Datenschutz haben, so wenden
        Sie sich bitte an: <br />
        <a href="mailto:hello@spicymedia.io">hello@spicymedia.io</a>
      </p>
      <p>
        <em>Stand, 01. September 2018</em>
      </p>
      <p>&nbsp;</p>
    </Text>
  </Wrapper>
);
